import axios from "axios";
import { CreatePayload } from "../Pages/AddBeneficiaryMinDetails/Action/createBenficiaries";
import apiConfig from "../apiConfig/apiConfig";
import { persister } from "../Redux/store";

const baseUri = apiConfig.api.baseURL;
// console.log("Base URI for API calls:", baseUri);
const urls = {
  USER_URI: `${baseUri}/auth/api/v1`,
  // USER_URI: "http://localhost:3002/auth/api/v1",
  OPS_URI: `${baseUri}/ops/api/v1`,
  BEN_URI: `${baseUri}/beneficiary/api/v1`,
  // BEN_URI: "http://localhost:3001/beneficiary/api/v1",
  AZURE_URI: `${baseUri}/azure/api/v1`,
  TICKET_URI: `${baseUri}/ticket/api/v1`,
  HOSPITAL_URI: `${baseUri}/hospital/api/v1/hospital`,
  PAYMENT_URI: `${baseUri}/payment/api/v1`,
  //PAYMENT_URI:"http://localhost:3009/payment/api/v1",
  COMPANY_URI: `${baseUri}/company/api/v1/company-service/partnerCompanies`,
  BACKEND_JOBS_URI: `${baseUri}/backendjobs/api/v1`,
  CHATBOT_URI: `${baseUri}/aiagent/api/v1`,
  //  CHATBOT_URI: `/chatbot`,
};
const axiosInstance = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: {
    "content-type": "application/json",
    Accept: "application/json",
  },
});

//beneficiary

export const getAllBeneficiariesData = (subId: string) =>
  axiosInstance.get(
    `${urls.BEN_URI}/beneficiary/find-by-subscriber-id/${subId}`
  );
export const updateBenAddressById = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/address-service/update-address/${benId}`,
    payload
  );
export const addBeneficiaries = (payload: CreatePayload) =>
  axiosInstance.post(
    `${urls.BEN_URI}/beneficiary/create-many-beneficiary`,
    payload
  );
export const createB2CBeneficiaries = (payload: CreatePayload) =>
  axiosInstance.post(
    `${urls.BEN_URI}/beneficiary/create-b2c-beneficiaries`,
    payload
  );
export const getBeneficiaryByUserId = (id: string) =>
  axiosInstance.get(`${urls.BEN_URI}/beneficiary/find-by-id/${id}`);
export const getSingleBenData = (benId: string) =>
  axiosInstance.get(`${urls.BEN_URI}/beneficiary/find-by-id/${benId}`);
export const updateBeneficiaryPersonalInfo = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/personal-info/update-personal-info/${benId}`,
    payload
  );

export const getSubscriberById = (id: string) =>
  axiosInstance.get(`${urls.BEN_URI}/subscriber/${id}`);
export const getSubscriberByUserId = (id: string) => axiosInstance.get(`${urls.BEN_URI}/subscriber/find-by-userId/${id}`);

// Beneficiary Index (backend-jobs)
export const getBeneficiaryIndexes = () =>
  axiosInstance.get(
    `${urls.BACKEND_JOBS_URI}/beneficiary-index/indices/by-subscriber`
  );

// temporary beneficiary ;
export const activateTempBen = (payload: any) =>
  axiosInstance.patch(`${urls.BEN_URI}/temp-ben/${payload.benId}`, payload);

export const signupForHospital = (payload: any) =>
  axiosInstance.post(`${urls.BEN_URI}/temp-ben/signup`, payload);

// Beneficiary Address
export const deleteBeneficiaryAddress = (benId: string, addressId: string) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/address-service/delete-address/${benId}`,
    { ID: addressId }
  );
export const addBeneficiaryAddress = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/address-service/create-address/${benId}`,
    payload
  );
export const updateBeneficiaryAddress = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/address-service/update-address/${benId}`,
    payload
  );

// Beneficiary Emergency Contact
export const addBeneficiaryEmergencyContact = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/emergency-contacts/${benId}`,
    payload
  );
export const deleteBeneficiaryEmergencyContact = (
  benId: string,
  payload: any
) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/emergency-contacts/delete-emergency-contact/${benId}`,
    payload
  );
export const updateBeneficiaryEmergencyContact = (
  benId: string,
  payload: any
) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/emergency-contacts/update-emergency-contact/${benId}`,
    payload
  );

// Beneficiary Insurance

export const addBeneficiaryInsurance = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/insurance-policies-service/create-insurance-policy/${benId}`,
    payload
  );

export const deleteBeneficiaryInsurance = (benId: string, policyId: string) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/insurance-policies-service/delete-insurance-policy/${benId}/policyId/${policyId}`
  );
export const updateBeneficiaryInsurance = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/insurance-policies-service/update-insurance-policy/${benId}`,
    payload
  );

// Beneficiary ContactUs
export const contactUs = (payload: any) =>
  axiosInstance.post(`${urls.BEN_URI}/contactus`, payload);

// Consent Management
export const saveConsentInfo = (payload: any) =>
  axiosInstance.post(`${urls.USER_URI}/terms-condition-consent`, payload);

export const checkConsentStatus = (benId: any) =>
  axiosInstance.get(`${urls.USER_URI}/terms-condition-consent/${benId}`);

// Hospital
export const getNearByHospital = (payload: any) =>
  axiosInstance.post(`${urls.HOSPITAL_URI}/nearby`, payload);
export const createHospital = (payload: any) =>
  axiosInstance.post(`${urls.HOSPITAL_URI}`, payload);
export const getHospitalById = (id: string) =>
  axiosInstance.get(`${urls.HOSPITAL_URI}/${id}`);

//hospital-service - unified query API
export const queryHospitals = (payload: any, controller?: AbortController) => {
  return axiosInstance.post(
    `${urls.HOSPITAL_URI}/query`,
    payload,
    controller ? { signal: controller.signal } : {}
  );
}


//AUTH SERVICE
export const sendOtpReq = (payload: any) =>
  axiosInstance.post(`${urls.USER_URI}/auth/send-otp-v2`, payload);
export const verifyOtp = (data: any) =>
  axiosInstance.post(`${urls.USER_URI}/auth/login-with-otp-v2`, data);
export const logOutUser = () =>
  axiosInstance.get(`${urls.USER_URI}/auth/logout`);
export const updateUserMobileNumber = (userId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.USER_URI}/user/add-mobile-number/${userId}`,
    payload
  );
export const sendOtpForActivation = (payload: any) =>
  axiosInstance.post(
    `${urls.USER_URI}/auth/send-otp-unregisterd-user`,
    payload
  );
export const verifyOtpForActivation = (payload: any) =>
  axiosInstance.post(
    `${urls.USER_URI}/auth/verify-otp-unregistered-user`,
    payload
  );
export const getUserById = (payload: any) =>
  axiosInstance.get(`${urls.USER_URI}/user/${payload.id}`);
export const getDocumentBaseUrl = `${urls.AZURE_URI}/signedUrl/get-document`;

// B2C payment service
export const createB2CSubscription = (payload: any) => axiosInstance.post(`${urls.PAYMENT_URI}/razorpay-subscription`, payload)
export const checkB2CPaymentStatus = (payload: any) => axiosInstance.patch(`${urls.PAYMENT_URI}/razorpay-subscription/update-subscriber-subscription-status`, payload)
export const getSubscriptionByUserId = (userId: string) => axiosInstance.get(`${urls.PAYMENT_URI}/razorpay-subscription/get-by-user-id/${userId}`)
export const getSubscriptionById = (subscriptionId: string) => axiosInstance.get(`${urls.PAYMENT_URI}/razorpay-subscription/get-by-subscription-id/${subscriptionId}`)
// B2C Subscription API'S ..send otp
export const b2cUserSendOtp = (payload: any) =>
  axiosInstance.post(`${urls.USER_URI}/user/b2c-user/send-otp`, payload);
// B2C Verify Otp..
export const b2cVerifyOtp = (payload: any) =>
  axiosInstance.post(`${urls.USER_URI}/user/b2c-user/verify-otp`, payload);
// B2C Create user..
export const createB2CUser = (payload: any) =>
  axiosInstance.post(`${urls.USER_URI}/user/create-b2c-user`, payload);
//localhost:3009/api/v1/plans/fetch-all-plans
export const fetchSubscriptionPlan = () =>
  axiosInstance.get(`${urls.PAYMENT_URI}/plans/fetch-all-plans`);
export const fetchSubscriptionPlanWithPlanId = () =>
  axiosInstance.get(`${urls.PAYMENT_URI}/plans/fetch-all-plans`);
export const fetchPlanById = (planId: string) =>
  axiosInstance.get(`${urls.PAYMENT_URI}/plans/fetch-plan-by-planId/${planId}`);
export const fetchPlansByCompanyId = (companyId: string) =>
  axiosInstance.get(`${urls.PAYMENT_URI}/plans/fetch-all-plans?companyId=${companyId}`);
// B2C Coupon validation
export const validateCoupon = (payload: { offerName: string, category: string }) =>
  axiosInstance.post(`${urls.PAYMENT_URI}/razorpay-subscription/validate-offer`, payload);
//fetch all the subscription of a subscriber
export const getAllSubscriptionOfSubscriber = (userId: string) => axiosInstance.get(`${urls.PAYMENT_URI}/razorpay-subscription/get-all-subscription-by-user-id/${userId}`)
export const getTicketsBySubscriberId = (
  subscriberId: string,
  pageNumber?: number,
  pageSize?: number,
) =>
  axiosInstance.get(`${urls.TICKET_URI}/ticket/by-subscriber`, {
    params: { subscriberId, pageNumber, pageSize },
  });
// Medical info
export const saveMedicalInfo = (benId: string, payload: any) =>
  axiosInstance.patch(
    `${urls.BEN_URI}/beneficiary/medical-info-record/${benId}`,
    payload
  );
export const getMedicalInfo = (benId: string) =>
  axiosInstance.get(`${urls.BEN_URI}/beneficiary/medical-info-record/${benId}`);
//azure
export const fetchLatAndLongHttp = async (place_id: string) =>
  await axiosInstance.get(
    `${urls.AZURE_URI}/google-map/getgeocode?place_id=${place_id}`
  );
export const fetchGeoCodeFromAddressHttp = async (addressText: string) =>
  await axiosInstance.post(
    `${urls.AZURE_URI}/google-map/getgeocode`,
    { addressText: addressText }
  );
export const fetchAutoSuggestedHospitalByHttp = async (input: string, city: string) =>
  await axiosInstance.get(
    `${urls.AZURE_URI}/google-map/autocomplete_hospital?input=${input}&city=${city}`
  );
export const getAzureSignedUrl = (
  docName: string,
  benId: string,
  docType: string
) =>
  axiosInstance.post(`${urls.AZURE_URI}/signedUrl/generateSignedUrl`, {
    docName,
    benId,
    docType,
  });

export const uploadFileHttp = (payload: any) => axiosInstance.post(`${urls.AZURE_URI}/signedUrl/uploads`, payload, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
})

export const getDocument = (url: string) => axiosInstance.get(url, {
  responseType: "blob"
})


export const getGMapAddress = (
  address1: string,
  address2: string,
  city: string,
  state: string,
  pincode: string
) =>
  axiosInstance.get(
    `${urls.AZURE_URI}/google-map?address1=${address1}&address2=${address2}&city=${city}&state=${state}&pincode=${pincode}`
  );

export const generateSasToken = () => {
  return axiosInstance.get(
    `${urls.AZURE_URI}/signedUrl/regenerateSaSToken`,
    {}
  );
};

//Ticket service
export const raisedEmergencyWithCall = (
  benId: string,
  mobile: string,
  lat: string | null,
  lng: string | null
) =>
  axiosInstance.get(
    `${urls.TICKET_URI}/qr/${benId}/${mobile}/${lat}/${lng}/em`
  );
export const raisedEmergencyWithQrWithMobile = (
  benId: string,
  mobile: string,
  lat: string | null,
  lng: string | null
) =>
  axiosInstance.get(
    `${urls.TICKET_URI}/qr/${benId}/${mobile}/${lat}/${lng}/qr`
  );
export const raisedEmergencyWithQR = (
  company: string,
  lat: string | null,
  lng: string | null
) =>
  axiosInstance.get(
    `${urls.TICKET_URI}/qr-noMobile/${company}/${lat}/${lng}/qr`
  );
export const raiseEmergencyWithCompanyId = (
  company: string,
  mobile: string,
  lat: string | null,
  lng: string | null
) =>
  axiosInstance.post(
    `${urls.TICKET_URI}/company-qr/${company}/${mobile}/${lat}/${lng}/companyQr`
  );

//Company Service
export const getCompanyByName = (company: string) =>
  axiosInstance.get(`${urls.COMPANY_URI}/${company}`);

export const getCompanyByWebContext = (webContext:string) =>
  axiosInstance.get(`${urls.COMPANY_URI}/${webContext}`);

export const getCompanyById = (companyId: string) =>
  axiosInstance.get(`${urls.COMPANY_URI}/find-company-by-id/${companyId}`);

export const findCompanyBySearchQuery = (searchQuery: string) => {
  return axiosInstance.get(`${urls.COMPANY_URI}/search/by-company-name?q=${searchQuery}`);
}

//razor_pay_validation_api
export const validatePayment = ({ payload }: any) => axiosInstance.post(`${urls.PAYMENT_URI}/order/verify`, payload)

// poco orders collection based on subscriberId
export const getPocoOrders = (subscriberId: string) => axiosInstance.get(`${urls.PAYMENT_URI}/poco-orders/get-by-subscriberId/${subscriberId}`)

//benId_Mapping to duplicate Qr//
export const findBenIdAlreadyMapped = (duplicateId: string) => axiosInstance.get(`${urls.OPS_URI}/bulk-qr-ben/query?_id=${duplicateId}&activeFlag=true`)//dynamic_query_api

export const findBenIdAlreadyMappedByBenId = (benId: string) => axiosInstance.get(`${urls.OPS_URI}/bulk-qr-ben/query?benId=${benId}&activeFlag=true`)//dynamic_query_api

export const mapBenIdToDuplicateId = ({ benPayload, qrId }: { benPayload: { benId: string, companyName?: string, activeFlag: boolean }, qrId: string }) => axiosInstance.patch(`${urls.OPS_URI}/bulk-qr-ben/update?_id=${qrId}`, benPayload)//mapBenId

export const verifyToken = () => axiosInstance.post(`${urls.USER_URI}/auth/verify-token`, {})

// JWT SSO — uses plain axios to bypass the refresh-token interceptor
export const jwtSsoValidateToken = (token: string, webContext: string) =>
  axios.post(`${urls.USER_URI}/sso-services/sso-validation`, { token, webContext }, { withCredentials: true })

export const jwtSsoLogin = (sessionId: string, webContext: string, user: { email: string; phone: string; name?: string; employee_id?: string; user_data?: any }) =>
  axios.post(`${urls.USER_URI}/sso-services/process-user-payload`, {
    session_id: sessionId,
    webContext,
    email: user.email,
    phone: user.phone,
    name: user.name,
    employee_id: user.employee_id,
    user_data: user.user_data,
  }, { withCredentials: true })

// Chatbot
export interface ChatRequest {
  sessionId: string;
  beneficiaryId: string;
  message: string;
}
export interface ChatAction {
  label: string;
  actionKey: string;
  metadata?: Record<string, any>;
}
export interface IndexScores {
  data_Index: number;
  hospital_Index: number;
  ambulance_Index: number;
  overall_Index: number;
  personalInfo_score: number;
  address_score: number;
  emergencyContact_score: number;
  insurance_score: number;
  medicalInfo_score: number;
  preferredHospital_score: number;
}
export interface ChatResponse {
  sessionId: string;
  message: string;
  actions: ChatAction[];
  indexScores: IndexScores;
}
export interface HistoryMessage {
  role: "user" | "assistant";
  content: string;
}
export interface ChatHistoryResponse {
  messages: HistoryMessage[];
  hasMore: boolean;
}
export const chatWithBot = (payload: ChatRequest) =>
  axiosInstance.post<ChatResponse>(`${urls.CHATBOT_URI}/chat`, payload);
export const getChatHistory = (sessionId: string, offset: number, limit: number) =>
  axiosInstance.get<ChatHistoryResponse>(`${urls.CHATBOT_URI}/chat/history`, {
    params: { sessionId, offset, limit },
  });


axiosInstance.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest.isRetry = true;
      try {
        await axios.post(`${urls.USER_URI}/auth/refresh-token`, {}, {
          withCredentials: true,
        });
        return axiosInstance.request(originalRequest);
      } catch (err) {
        console.log(err);
        localStorage.removeItem("beneficiariesData");
        localStorage.removeItem("userData");
        localStorage.removeItem("pwaBen");
        localStorage.removeItem("sasToken");
        await persister.purge();
        window.location.reload();
      }
      localStorage.clear();
      localStorage.removeItem("beneficiariesData");
      localStorage.removeItem("userData");
      localStorage.removeItem("persist:MainData");
      await persister.purge();
      window.location.reload();
    }
    throw error;
  }
);
export default axiosInstance;
